import { defineStore } from 'pinia'
import { db } from '../firebaseConfig.js'
import { doc, getDoc } from 'firebase/firestore'

export const useAppStore = defineStore('app', {
  state: () => ({
    currentUser: null,
    userProfile: {},
    timestamp: '0/1/2021 10:25',
    mildHypoThreshold: 65,
    bpTargetMin: 65,
    bpTargetMax: 85,
    brightness: 1.0
  }),

  actions: {
    setCurrentUser(val) {
      this.currentUser = val
    },
    setUserProfile(val) {
      this.userProfile = val
    },
    setTimestamp(val) {
      this.timestamp = val
    },
    setBPTargetMax(val) {
      this.bpTargetMax = parseInt(val, 10)
    },
    setBPTargetMin(val) {
      this.bpTargetMin = parseInt(val, 10)
    },
    setMildHypoThreshold(val) {
      this.mildHypoThreshold = parseInt(val, 10)
    },
    setBrightness(val) {
      this.brightness = val
    },
    async fetchUserProfile() {
      if (!this.currentUser?.uid) return
      try {
        const docRef = doc(db, 'users', this.currentUser.uid)
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
          this.userProfile = docSnap.data()
        }
      } catch (err) {
        console.error('Error fetching user profile:', err)
      }
    }
  }
})
